import React, { useMemo } from 'react';
import { generatePath, Link, useParams } from 'react-router-dom';

import ROUTES_PATH from '@/router/routesPathConfig';

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Stack from '@mui/material/Stack';
import {
  DrawerStatic,
  DrawerHeader,
  DrawerFooter,
  DRAWER_STATIC_WIDTH,
} from '@/components/mui/Layouts/components/Drawer';
import { LayoutRoot, LayoutContent } from '@/components/mui/Layouts/components/Layout';
import { AppBarStatic, AppBarItemDivider } from '@/components/mui/Layouts/components/AppBar';
import SettingsLink from '@/components/mui/Layouts/components/Drawer/SettingsLink';
import HelpDropdown from '@/components/mui/Layouts/components/HelpDropdown';
import LocaleSelect from '@/components/mui/LocaleSelect';
import AppbarLogoCompany from '@/components/mui/Layouts/components/AppbarLogoCompany';
import AccountDropdown from '@/components/mui/Layouts/components/AccountDropdown';
import BackToArrow from '@/components/mui/Layouts/PayCompanySettings/components/BackToArrow';
import FullscreenIconButton from '@/components/mui/Layouts/components/FullscreenIconButton';
import AsideLogo from '@/components/mui/Layouts/components/AsideLogo';
import ApplicationDropdown from '@/components/mui/Layouts/components/ApplicationDropdown';

const LayoutPayCompanySettings = ({ children }) => {
  const { companyId } = useParams();
  const path = useMemo(() => generatePath(ROUTES_PATH.PAY_COMPANY.absolute, { companyId }), [companyId]);
  return (
    <LayoutRoot display="flex" flexGrow="1">
      <DrawerStatic variant="permanent">
        <DrawerHeader>
          <Link to={path}>
            <AsideLogo />
          </Link>
        </DrawerHeader>
        <DrawerFooter>
          <List>
            <SettingsLink />
          </List>
        </DrawerFooter>
      </DrawerStatic>

      <AppBarStatic>
        <Box flexShrink={0} display="flex" alignItems="center">
          <BackToArrow />
          <AppbarLogoCompany />
        </Box>

        <Stack direction="row" alignItems="center" spacing={1} flexShrink={0} ml="auto">
          <FullscreenIconButton />
          <AppBarItemDivider />
          <HelpDropdown />
          <LocaleSelect flagOnly />
          <ApplicationDropdown />
          <AccountDropdown />
        </Stack>
      </AppBarStatic>

      <LayoutContent sx={{ maxWidth: `calc(100% - ${DRAWER_STATIC_WIDTH}px)` }}>
        <DrawerHeader />
        {children}
      </LayoutContent>
    </LayoutRoot>
  );
};

export default LayoutPayCompanySettings;
